import Nota from "@/pages/relatorio/Nota";
import Venda from "@/pages/relatorio/Venda";
import OS from '@/pages/relatorio/Os'

export const relatorioRoutes = [
  {
    path: "/relatorios/notas",
    name: "relatorioNotas",
    component: Nota,
  },
  {
    path: "/relatorios/venda",
    name: "relatorioVendas",
    component: Venda,
  },
  {
    path: "/relatorios/os",
    name: "relatorioOs",
    component: OS,
  },
];

export default {};
